/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import store from "../store/store";
import psl from 'psl';

const storeData = store.getState();
const authData = storeData.auth.tenantInfo;
var logoutUrl = "";
if (authData.tenantId) {
  var url = authData.baseUrl + authData.logoutUrl;
  logoutUrl = url.replace("${}", authData.realm);
}

const getCookieDomain = (hostname) => {
  try {
    const parsed = psl.parse(hostname);
    return parsed.domain ? `.${parsed.domain}` : hostname;
  } catch {
    return hostname;
  }
};

const domain = getCookieDomain(window.location.hostname);
console.log('check domain', domain);

export default {
  imageUrl: `${window.REACT_APP_BIZ_IMAGE_URL}`,
  busInternalUrl: `${window.REACT_APP_INTG_API_URL}/cumulator/internal/v1`,
  busV4Url: `${window.REACT_APP_INTG_API_URL}/cumulator/api/v4`,
  busV44UrlPublic: `${window.REACT_APP_INTG_API_URL}/cumulator/api/v4.4`,
  busV44Url: `${window.REACT_APP_INTG_API_URL}/cumulator/internal/api/v4.4`,
  busPublicServiceUrl: `${window.REACT_APP_INTG_API_URL}/cumulator/api/v1`,
  busOpenServiceUrl: `${window.REACT_APP_INTG_API_URL}/cumulator/internal/verify/v1`,
  apiPortalRegistrationUrl: `${window.REACT_APP_INTG_API_URL}/lcm`,
  // logoutUrl: `${window.REACT_APP_LOGOUT_URL}`,
  logoutUrl: `${authData.tenantId ? logoutUrl : authData.logoutUrl}`,
  genericReportUrl: `${window.REACT_APP_INTG_API_URL}/cumulator/api/v4/reports`,
  cbizBaseUrl: `${window.REACT_APP_CBIZ_BASE_URL}`,

  // version 4.4
  busV4Url2: `${window.REACT_APP_INTG_API_URL}/cumulator/api/v4.4`,
  busInternalUrl2: `${window.REACT_APP_INTG_API_URL}/cumulator/internal/api/v4.4`,

  flowableUrl: `${window.REACT_APP_FLOWABLE_URL}`,
  openAuthUrl: `${window.REACT_APP_INTG_API_URL}/cumulator/auth`,
  openUserUrl: `${window.REACT_APP_INTG_API_URL}/cumulator/v4`,
  // envDomain: `${window.REACT_APP_DOMAIN}`,
  envDomain: `${domain}`,
  // zulipBaseUrl: `${window.location.origin}`,
  // zulipUiUrl: `${window.location.origin}/zulip`,
  zulipBaseUrl: `${window.REACT_APP_ZULIP_BASE_URL ? window.REACT_APP_ZULIP_BASE_URL : window.location.origin}`,
  zulipUiUrl: `${window.REACT_APP_ZULIP_BASE_URL ? window.REACT_APP_ZULIP_BASE_URL : window.location.origin}/zulip`,

  // iotlcmUrl:`${window.REACT_APP_INTG_API_URL}/api/v1`,
  // intgBaseUrl:`${window.REACT_APP_INTG_API_URL}`,
  // agentIdBaseUrl: `${window.REACT_APP_INTG_API_URL}/lcm`,
  // tabToBackendMap:{
  //     "APP_VARIANT":"solutions"
  // },
};
